import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import { animated, useSpring } from '@react-spring/web'
import { useThemeType } from '../../hooks/useThemeType'

const useStyles = makeStyles(() => ({
  bg: {
    backgroundSize: 'cover !important',
    transition: 'background var(--transition-duration-medium) linear, filter var(--transition-duration-medium) linear'
  }
}))

function Background ({ children, lightUrl, darkUrl, lightBgColor, darkBgColor, className, style }) {
  const classes = useStyles()
  const themeType = useThemeType()
  const bg = useMemo(() => {
    if (themeType === 'light') {
      return lightUrl ? `url(${lightUrl})` : undefined
    }
    if (themeType === 'dark') {
      return darkUrl ? `url(${darkUrl})` : undefined
    }
    return undefined
  }, [themeType, lightUrl, darkUrl])

  const bgColor = useMemo(() => {
    if (themeType === 'light') {
      return lightBgColor
    }
    if (themeType === 'dark') {
      return darkBgColor
    }
    return undefined
  }, [themeType, lightBgColor, darkBgColor])

  const [springs] = useSpring(() => ({
    from: { opacity: 0 },
    to: { opacity: 1 }
  }), [])

  return (
    <animated.div
      className={clsx(classes.bg, className)}
      style={{
        ...(style || {}),
        position: 'absolute',
        minWidth: '100vw',
        width: '100%',
        height: '100%',
        minHeight: '100%',
        zIndex: 0,
        top: 0,
        margin: 0,
        background: bg || bgColor,
        backgroundSize: 'cover !important',
        ...springs
      }}
    >
      {children}
    </animated.div>
  )
}

Background.propTypes = {
  children: PropTypes.node,
  lightUrl: PropTypes.string,
  darkUrl: PropTypes.string,
  lightBgColor: PropTypes.string,
  darkBgColor: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string
}

export default Background
